import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import en from './locales/en.json'
import ro from './locales/ro.json'

import reducers from './redux/reducers'
import sagas from './redux/sagas'

export default {
  name: 'createOrderFast',
  menu: [
    {
      title: <FormattedMessage id="createOrder.menu.title" />,
      key: 'createOrderFast',
      url: '/createOrderFast',
      icon: 'icmn icmn-history',
      // roles: ['business'],
    },
  ],
  routes: [
    {
      path: '/createOrderFast',
      async lazy() {
        const Comp = await import('./pages')
        return { Component: Comp.default }
      },
      exact: true,
    },
  ],
  locales: {
    en,
    ro,
  },
  reducers,
  sagas,
}
